import React, { forwardRef, useMemo } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Body2, Dot, ExpandSingle, Header2 } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { CompanyNameContainer } from "~/components/Companies/CompanyNameContainer";
import ProjectName from "~/components/project/ProjectName";
import { makeGetUserAssignmentsCountSelector } from "~/store/selectors/selector.userTasks";

const TeamProjectItem = forwardRef(
  ({ id, companyId, membersIds, isExpanded, handleCollapsedProjects, className }, ref) => {
    const getCountAssignments = useMemo(() => makeGetUserAssignmentsCountSelector(id, membersIds), [id, membersIds]);
    const countAssignments = useSelector(getCountAssignments);

    return (
      <div
        className={classNames("my_work_project_list_wrapper", className)}
        ref={ref}
      >
        <div className="my_work_project_list tw-flex tw-items-center">
          <ExpandSingle
            expanded={isExpanded}
            onClick={handleCollapsedProjects}
            className="tw-mr-3 tw-ml-6 tw-cursor-pointer tw-text-secondary tw-shrink-0"
          />
          <Header2 className="tw-leading-6 tw-overflow-hidden">
            <Link
              to={`/projects/${id}`}
              className="my_work_project_name tw-text-secondary tw-flex"
            >
              <span className="tw-truncate">
                <ProjectName id={id} />
              </span>
              <span>&nbsp;({countAssignments})</span>
            </Link>
          </Header2>
          <Dot
            className="tw-shrink-0"
            color="var(--color-theme-500)"
            size={4}
          />
          <Body2
            color="tertiary"
            className="tw-ml-2 tw-truncate"
          >
            <CompanyNameContainer id={companyId} />
          </Body2>
        </div>
      </div>
    );
  }
);

TeamProjectItem.propTypes = {
  id: PropTypes.number.isRequired,
  companyId: PropTypes.number.isRequired,
  membersIds: PropTypes.array,
  className: PropTypes.string,
  isExpanded: PropTypes.bool,
  handleCollapsedProjects: PropTypes.func,
};

TeamProjectItem.displayName = "TeamProjectItem";

export default React.memo(TeamProjectItem);
